
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/[storyId]",
      function () {
        return require("private-next-pages/story/[storyId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/story/[storyId]"])
      });
    }
  